import React from 'react';
import { Button, colors, makeStyles, Paper } from '@material-ui/core';

import useAuthentication from 'domain/authentication/useAuthentication';

import ProfileMenu from 'components/menu/ProfileMenu';
import Title from 'components/typography/Title';

const useStyles = makeStyles({
  root: {
    height: 64,
    width: 64,
    borderRadius: 32,
  },
  button: {
    height: 64,
    width: 64,
    borderRadius: 32,
    color: colors.grey[50],
    backgroundColor: colors.red[400],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
});

const ProfileButton = () => {
  const classes = useStyles();
  const { user } = useAuthentication();

  return (
    <ProfileMenu
      userName={user.displayName}
      email={user.email}
      renderButton={(onClick) => {
        return (
          <Paper elevation={3} className={classes.root}>
            <Button className={classes.button} onClick={onClick}>
              <Title variant="h6">{`${user.firstNameLetter()}${user.lastNameLetter()}`}</Title>
            </Button>
          </Paper>
        );
      }}
    ></ProfileMenu>
  );
};

export default ProfileButton;
